import { render, staticRenderFns } from "./header-menu-add-options.vue?vue&type=template&id=3237c088"
import script from "./header-menu-add-options.vue?vue&type=script&lang=js"
export * from "./header-menu-add-options.vue?vue&type=script&lang=js"
import style0 from "./header-menu-add-options.vue?vue&type=style&index=0&id=3237c088&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports